import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

import { default as BaseButton } from '../../../BaseComponents/Button';
import { useRenderers } from '../../../renderProps';
import { useTheme } from '../../../theme';
import { TABLET_MIN_WIDTH } from '../../../utils';
import { TabTypes } from '../../types';

export interface ButtonRendererProps {
	notActive: boolean;
	onClear?: React.DispatchWithoutAction;
	isDoneable: boolean;
	onDone: React.DispatchWithoutAction;
	tab: TabTypes;
	routeType?: 'outbound' | 'return';
	isDateToSelected?: boolean;
	isDateBackSelected?: boolean;
	onClose: React.DispatchWithoutAction;
	isMultyCity?: boolean;
}
interface Props {
	showButtons: boolean;
	outDate: Date;
	returnDate: Date;
	buttonRendererProps: ButtonRendererProps;
}

const FooterButtons: React.FC<Props> = ({ showButtons, outDate, returnDate, buttonRendererProps }) => {
	const { t } = useTranslation('SearchFormDatepicker');
	const { SearchFormDatepickerStyles: datepickerTheme } = useTheme('SearchFormDatepicker');

	const isMobile = useMediaQuery({ maxWidth: TABLET_MIN_WIDTH - 1 });
	const { renderAdaptiveSearchFormDatepickerControls } = useRenderers();

	if (renderAdaptiveSearchFormDatepickerControls) {
		return <>{renderAdaptiveSearchFormDatepickerControls(buttonRendererProps)}</>;
	}

	if (!showButtons || (isMobile && !outDate)) {
		return null;
	}

	return (
		<div className={datepickerTheme.footer__buttons}>
			<BaseButton
				variant="smallSecondary"
				className={datepickerTheme.footer__clear}
				data-test-id="datepicker-clear"
				disabled={!buttonRendererProps.notActive}
				onClick={buttonRendererProps.onClear}
			>
				{t('Clear')}
			</BaseButton>

			<BaseButton
				variant="smallThird"
				className={datepickerTheme.footer__done}
				data-test-id="datepicker-confirm"
				disabled={!buttonRendererProps.isDoneable}
				onClick={buttonRendererProps.isDoneable ? buttonRendererProps.onDone : null}
			>
				{outDate && !returnDate ? t('One way') : t('Done')}
			</BaseButton>
		</div>
	);
};

export default FooterButtons;
